import type { ScenarioRow } from '../../view/LoanScenario/Dashboard';
import {
  mockDeleteScenario,
  mockDuplicateScenario,
  mockGetScenarios,
} from '../../view/LoanScenario/mocks';

// Lists the user's saved scenarios.
export const getScenarios = (): Promise<ScenarioRow[]> => mockGetScenarios();

// Copies a scenario's pricing attributes into a new scenario.
export const duplicateScenario = (id: string): Promise<void> =>
  mockDuplicateScenario(id);

// Removes a scenario.
export const deleteScenario = (id: string): Promise<void> =>
  mockDeleteScenario(id);
